module.exports = { "default": require("core-js/library/fn/symbol/for"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/symbol/for.js
// module id = 61
// module chunks = 0